module.exports = __webpack_public_path__ + "static/grafika1-cc9619fedb3c234c1c9bc25b2925e003.png";